import {Pipe, PipeTransform} from '@angular/core';
import {TaskDto} from '../../../Models/Tasks/General/task.interface';

@Pipe({
  name: 'tasksType',
  standalone: false
})
export class TasksTypePipe implements PipeTransform {

  transform(items: TaskDto[], type?: string): TaskDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (type === 'checklist') {
      items = items.filter((item) => item.auditoria == 0 && !item.id_appcc);
    }

    if (type === 'audit') {
      items = items.filter((item) => item.auditoria == 1 && !item.id_appcc);
    }

    if (type === 'appcc') {
      items = items.filter((item) => item.id_appcc > 0);
    }

    return items;

  }

}
